import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { isTerminalStatus } from "../constants";

export function useUpload(uploadId: number | undefined) {
  return useQuery({
    queryKey: [{ entity: "uploads", scope: "detail", id: uploadId }],
    queryFn: async () => await apiClient.getUpload({ params: { id: uploadId! } }),
    enabled: !!uploadId,
    refetchInterval: (query) => (query.state.data && isTerminalStatus(query.state.data.status) ? false : 3000),
  });
}
